/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The type of the verification method.
 */
export type VerificationMethodMultikeyType = 'Multikey' | 'EcdsaSecp256k1VerificationKey2019';
export const VerificationMethodMultikeyType = {
    Multikey: 'Multikey',
    EcdsaSecp256K1VerificationKey2019: 'EcdsaSecp256k1VerificationKey2019',
} as const;
